import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as styles from "./JustificationDialog.module.scss";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { StructuredList } from "cprime-foundational-components";
import { StatusType } from "../../enums/RolesEnum";

interface JustificationDialogProps {
  isSubRequestId?: boolean;
  isStatus?: boolean;
  open: boolean;
  onClose: () => void;
  row?: any | null;
}
function JustificationDialog({ open, onClose, row }: JustificationDialogProps) {
  const scssClass = styles as any;
  const [flatData, setFlatData] = useState<any[]>([]);

  React.useEffect(() => {
    if (row) {
      if (isRequestStatus) {
        const dat = flattenRequestedFeaturesRequest(
          Array.isArray(row) ? row : [row],
        );
        setFlatData(dat ?? []);
      } else {
        const datVal = flattenRequestedFeatures(
          Array.isArray(row) ? row : [row],
        );
        setFlatData(datVal ?? []);
      }
    }
  }, [row]);
  const flattenRequestedFeaturesRequest = (data: any[]) => {
    return data?.flatMap((item) =>
      item?.requested_feature?.map((feature: any) => ({
        subrequest_id: item?.subrequest_id,
        ...feature,
      })),
    );
  };
  const requestStatusData = (data: any[]) => {
    const modifiedData = flatData?.map((_item) => {
      return {
        ..._item,
        id: _item?.subrequest_id,
        status:
          _item?.status?.toLowerCase() === "denied" ? (
            <Stack direction="row" spacing={1}>
              <CancelIcon fontSize="small" color="error" />
              <p
                style={{
                  color: "#000000",
                  textTransform: "capitalize",
                }}
              >
                Denied
              </p>
            </Stack>
          ) : _item?.status?.toLowerCase() ==
            StatusType?.COMPLETED?.toLowerCase() ? (
            <Stack direction="row" spacing={1}>
              <CheckCircleIcon fontSize="small" color="success" />
              <p
                style={{
                  color: "#000000",
                  textTransform: "capitalize",
                }}
              >
                {StatusType.COMPLETED}
              </p>
            </Stack>
          ) : _item?.status && _item?.status !== null ? (
            <Stack direction="row" spacing={1}>
              <RemoveCircleIcon fontSize="small" style={{ color: "#9e9e9e" }} />
              <p
                style={{
                  color: "#000000",
                  textTransform: "capitalize",
                }}
              >
                {_item?.status}
              </p>
            </Stack>
          ) : (
            <>-</>
          ),
      };
    });
    return modifiedData;
  };
  const flattenRequestedFeatures = (data: any[]) => {
    // if (!Array.isArray(data)) return [];

    const isFlatPayload = data?.every(
      (item) =>
        item &&
        typeof item === "object" &&
        "feature_name" in item &&
        "subrequestId" in item,
    );

    if (isFlatPayload) {
      return data?.map((item) => ({
        ...item,
        subrequest_id: item?.subrequestId,
        group_name: item?.group_name,
      }));
    }

    return data?.flatMap(
      (item) =>
        item?.requested_feature?.map((feature: any) => ({
          subrequest_id: item?.subrequest_id,
          ...feature,
        })) || [],
    );
  };

  const statusColumn = [
    {
      field: "subrequest_id",
      headerName: "Sub-Request ID",
    },
    {
      field: "status",
      headerName: "Status",
    },
    {
      field: "group_name",
      headerName: "Feature Group",
    },
    {
      field: "feature_name",
      headerName: "Feature",
    },
    {
      field: "permission_name",
      headerName: "Permissions",
    },
    {
      field: "justification",
      headerName: "Justification",
    },
  ];
  const approveColumn = [
    {
      field: "subrequest_id",
      headerName: "Sub-Request ID",
    },
    {
      field: "group_name",
      headerName: "Feature Group",
    },
    {
      field: "feature_name",
      headerName: "Feature",
    },
    {
      field: "permission_name",
      headerName: "Permissions",
    },
    {
      field: "justification",
      headerName: "Justification",
    },
  ];
  const location = useLocation();
  const isRequestStatus = location?.pathname === "/request-status";

  return (
    <Dialog
      open={open}
      // onClose={() => {
      //   onClose();
      //   setFlatData([]);
      // }}
      fullWidth
      maxWidth={`lg`}
      sx={{
        "& .MuiDialogContent-root": {
          paddingBottom: "2rem !important",
          paddingTop: "0px !important",
          paddingLeft: "1.5rem !important",
          paddingRight: "1.5rem !important",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 400,
          fontSize: "1.5rem",
          lineHeight: "2rem",
          color: "#000000",
        }}
      >
        Features Requested
        <IconButton
          onClick={() => {
            onClose();
            setFlatData([]);
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div style={{ maxHeight: "calc(100vh - 300px)", width: "100%" }}>
          <StructuredList
            columns={isRequestStatus ? statusColumn : approveColumn}
            className={scssClass?.backgroundTable}
            rows={
              flatData
                ? isRequestStatus
                  ? requestStatusData(flatData)
                  : flatData
                : row
            }
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default JustificationDialog;
